import angular from "angular";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {PaymentService} from "@common/service/payment.service";
import {CacheService} from "@common/service/cache.service";
import {SubjectService} from "@common/service/subject.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {IAppRootScopeService} from "@app/app.definition";
import _ from "lodash";
import {Util} from "@common/util";
import {Subject} from "@common/model/subject";
import jsonLogic from "json-logic-js";

const ALL_TEAMS = 'All Teams';


export interface ICustomScope extends ng.IScope {
    element?: ng.IAugmentedJQuery;
    contentUrl?: string;
}

export interface IEcvPaginatedSubjList {
    init();

}

export class EcvPaginatedSubjList implements IEcvPaginatedSubjList {
    static $inject = ["$q", "$scope", "$rootScope", "$timeout", "BroadcastService",
        "ApiAdapterService", "SubjectService", "CacheService", "PaymentService"];
    selectedValue: any;
    selectedChange: any;
    clickOnNotFound: any;
    selectedItem: any;
    teamLimit: any;
    addNewMsg: any;
    withoutCache: boolean;
    fieldDisabled: boolean;
    teamPlaceholder: string;
    searchText: any;
    searchQuery: any = "";
    displayAs: string;
    formName: string;
    parentForm: any;
    tempItem: any;
    isFocused: boolean = false;
    loadFirstTime: boolean = true;
    addBtnPosition: any;
    selectAllBtnPosition: any;
    mugshotConfig: any;
    clickedOnBtn: boolean = false;
    multipleSelectedValue: any;
    multiple: any;
    mugshotBelow: any;
    sendingSelectedTeam: any;
    isEdgeIE: boolean = (isIE11 || window.navigator.userAgent.indexOf("Edge") > -1);
    isEdge: boolean = window.navigator.userAgent.indexOf("Edge") > -1;
    tempSearchText: any;
    disableSelectOpt: boolean;
    fieldName;
    mgshtTooltipClass;
    loadedSubjects;
    moreTeamsToLoad = true;
    size = 10;
    dataLoading = false;
    filterConfig;
    showAddBtn: boolean;
    canUsrCreateTeam;
    checkAccess;
    permissionCheck;
    totalSubjectElements: number;
    includeCustomAttributes;
    searchBy;
    isEmpty;
    isRequired = true;
    disableCnd = "false";
    customFilterConfig;
    searchFormat: string;
    searchPattern: string;
    lodash;
    teamDetails;    //details to be shown below team name in the list options
    teamDetailsAttr;
    teamDetailsRegex;   //used to mask input in teamDetails
    teamDetailsReplcStr;    //used to mask input in teamDetails
    constructor(
        private $q: angular.IQService,
        private $scope: ICustomScope,
        private $rootScope: IAppRootScopeService,
        private $timeout: angular.ITimeoutService,
        BroadcastService: BroadcastService,
        private $_api: JavaApiAdapterService,
        private SubjectService: SubjectService,
        private $_cache: CacheService,
        private PaymentService: PaymentService
    ) {
        let subListVm: any = this;
        subListVm.lodash = _;
        subListVm.isEmpty = _.isEmpty;
        $scope.$watch('subListVm.selectedValue', function (newVal, oldVal) {
            if (!!subListVm.selectedValue && subListVm.displayAs != 'global-cr') {
                if (subListVm.sendingSelectedTeam == "false") {
                    subListVm.SubjectService.getSubjectById(subListVm.selectedValue).then(sub => {
                        subListVm.selectedItem = sub;
                    });
                } else {
                    subListVm.selectedItem = subListVm.selectedValue;
                }
            } else {
                subListVm.init(false);
            }
        })

        BroadcastService.registerCallBack('new-created-item', $scope.$id, () => {
            this.searchQuery = this.searchText = '';
            this.moreTeams(0, true);
        });
        BroadcastService.registerCallBack('refresh-teams-drpdn', $scope.$id, () => {
            this.moreTeams(0, true);
        });
        $scope.$on('$destroy', function () {
            BroadcastService.removeCallBack('new-created-item', $scope.$id);
            BroadcastService.removeCallBack('refresh-teams-drpdn', $scope.$id);
            subListVm.loadedSubjects.forEach((x) => {
                x.selected = false;
            })
        })
    }

    init = (initial = true) => {
        let subListVm: any = this;
        subListVm.canUsrCreateTeam = this.$_cache.get('isCreateTeamAllow', true);
        let config = {
            tooltip: 'right',
            size: 'xs',
            hideStatus: true,
            forceUpdate: true
        }
        subListVm.teamDetailsAttr = Util.safeAccess(subListVm.teamDetails, ["attr"]);
        subListVm.teamDetailsRegex = Util.safeAccess(subListVm.teamDetails, ["regexPattern"]);
        subListVm.teamDetailsReplcStr = Util.safeAccess(subListVm.teamDetails, ["replacementString"]);
        if (!!this.loadedSubjects && this.sendingSelectedTeam == "false") {
            let item = this.loadedSubjects.find(x => x.subjectId == this.selectedValue);
            if (!!item) {
                this.selectedItem = item;
            }
            config.tooltip = 'top';
            config.size = 'small';
            config.hideStatus = false;
            config.forceUpdate = false;
        } else if (!!this.loadedSubjects && this.sendingSelectedTeam == "true" && !this.multiple && !this.mugshotBelow) {
            this.selectedItem = this.selectedValue;
        } else if (!!this.loadedSubjects && this.sendingSelectedTeam == "true" && !!this.multiple) {
            !this.multipleSelectedValue && (this.multipleSelectedValue = []);
            let multiTeams = this.multipleSelectedValue.map(function (x) {
                return x.subjectId;
            })
            this.loadedSubjects.forEach(function (x) {
                if (multiTeams.includes(x.subjectId)) {
                    x.selected = true;
                }
            })
        }
        this.mugshotConfig = config;
        this.parentForm = this.$scope.$parent[this.formName];
        if (this.isEdgeIE) {
            this.$timeout(function () {
                let el;
                if (subListVm.displayAs == 'global-cr') {
                    el = angular.element(".global-cr-height md-autocomplete input");
                    el.scope().$mdAutocompleteCtrl.isReadonly = true;
                } else {
                    el = angular.element(".team-member-directive md-autocomplete input");
                }
                let focus = function (event) {
                    setTimeout(function () {
                        document.body.focus();
                        window.removeEventListener('focus', focus);
                    }, 10);
                }
                window.addEventListener('focusout', function (event) {
                    if (el.is(':focus')) {
                        window.addEventListener('focus', focus);
                    }
                });
            }, 0);
        }

        if (!!initial) {
            $(window).on('scroll', function () {
                angular.element("#glbl-cr-drpdwn input").blur();
            });

            if (!this.dataLoading) {
                if (!this.loadedSubjects) {
                    this.loadedSubjects = [];
                } else {
                    this.loadedSubjects.splice(0, this.loadedSubjects.length);
                }
                this.moreTeams(0);
            }
            this.$timeout(() => {
                let rep = angular.element("#" + this.displayAs + "-" + this.fieldName + "-inpt .md-virtual-repeat-scroller");

                rep.on('scroll', (evt) => {
                    if (rep[0].scrollHeight - rep[0].clientHeight - rep[0].scrollTop < 5 && !this.dataLoading && this.moreTeamsToLoad) {
                        let scrollPos = rep[0].scrollTop;
                        let len = this.loadedSubjects.length;
                        (this.displayAs == 'global-cr' && len > 2) && (len--);
                        let pgSz = Math.ceil(len / this.size);
                        this.moreTeams(pgSz).then(() => {
                            rep[0].scrollTop = scrollPos;
                        });
                    }
                });
            }, 10);
        }
    }

    getClasses = () => {
        let classes = [];
        if (!!this.selectedItem && !this.mugshotBelow) {
            classes.push('input-filled')
        }
        if (this.displayAs == 'analytics-field-cr') {
            classes.push('analytics-input')
        }
        if (this.displayAs == 'assign-service-cr' || this.displayAs == 'manage-cr' || this.displayAs == 'analytics-field-multiple-cr') {
            classes.push('padding-left-0')
        }
        if (!!this.parentForm && this.parentForm.invalid && !this.selectedValue && this.multipleSelectedValue.length <= 0) {
            classes.push('error-bottom-line')
        }
        if (!!this.isFocused) {
            classes.push('border-radius-on-open')
        }
        if (!!this.selectedItem && (this.selectedItem.isFormerTeamMember || this.selectedItem.isFrozen)) {
            classes.push('padding-right-55')
        }
        if (isIE11) {
            classes.push('line-height-normal')
        }
        return classes;
    }

    setPosition = () => {
        let arr = ["top0", "top40", "top80", "top120", "top160", "top200", "top240"];
        this.selectAllBtnPosition = arr[0];
        if (this.loadedSubjects.length >= 6) {
            this.addBtnPosition = arr[6];
        } else {
            this.addBtnPosition = arr[this.loadedSubjects.length];
        }
    }
    getMoreSubjects = (pg: number) => {
        let deferred = this.$q.defer();
        let cachedSub, totalSubs;
        if (!this.withoutCache) {
            cachedSub = this.$_cache.getSortedSubjects();
            totalSubs = this.$_cache.getTotalSubjects();
        } else {
            cachedSub = [];
            totalSubs = this.totalSubjectElements;
        }
        let lowercaseQuery: string;
        let filter = _.cloneDeep(this.filterConfig);
        let customFilter = _.cloneDeep(this.customFilterConfig);
        let ret: Subject[] = _.filter<Subject>(cachedSub, filter);
        let start = pg * 10;
        let end = start + 10;
        let attributes = null;

            if(!!this.searchQuery) {
                lowercaseQuery = this.searchQuery.toLowerCase();
                !filter && (filter = {});
                !customFilter && (customFilter = {});
                let filterKeys = [];
                if (!!this.searchBy) {
                    if (!!this.searchBy.filterList) {
                        this.searchBy.filterList.forEach(key => {
                            filter[key] = lowercaseQuery;
                        });
                    } else if (!!this.searchBy.filter) {
                        filter[this.searchBy.filter] = lowercaseQuery;
                    }
                    !!this.searchBy.customFilter && (customFilter[this.searchBy.customFilter] = lowercaseQuery);

                    filterKeys = this.searchBy.filterList || [];
                    this.searchBy.filter && (filterKeys.push(this.searchBy.filter));
                } else {
                    filter['fullName'] = lowercaseQuery;
                    filterKeys.push('fullName');
                }
                let filterFunc = (item) => {
                    return  filterKeys.some(key =>
                        item[key] && item[key].toLowerCase().indexOf(lowercaseQuery.toLowerCase()) >= 0
                    );
                }
                ret = _.filter(ret, filterFunc);
            }

        if (ret.length >= end || (!filter && ret.length == totalSubs)) {
            deferred.resolve(ret.slice(start, end));
        } else {
            if (this.permissionCheck) {
                filter.permission = this.permissionCheck
            }
            if (!!this.includeCustomAttributes) {
                attributes = this.includeCustomAttributes;
            }
            this.$_api.getSubjectsV3(pg, 10, null, filter, !!this.includeCustomAttributes, attributes, this.$_cache.getPassword(), customFilter).then((data) => {
                if (!filter) {
                    data['subjects'].forEach((s: Subject) => {
                        if (!ret.find(sub => sub.subjectId == s.subjectId)) {
                            ret.push(s);
                        }
                    });
                    if (!this.withoutCache) {
                        this.$_cache.setSortedSubjects(ret);
                        this.$_cache.setTotalSubjects(data['totalElements']);
                    } else {
                        this.totalSubjectElements = data['totalElements'];

                    }

                }
                deferred.resolve(data['subjects']);
            });
        }
        return deferred.promise;
    }

    moreTeams = (pg, srchQryChange?) => {
        this.dataLoading = true;
        let deferred = this.$q.defer();
        let el = angular.element("#" + this.fieldName + "-drpdwn input");
        el.length > 0 && ((el.scope() as any).$mdAutocompleteCtrl.loading = true);

        this.getMoreSubjects(pg).then((data) => {
            let ret: any = data;
            el = angular.element("#" + this.fieldName + "-drpdwn input");
            if (!!srchQryChange) {
                this.loadedSubjects.splice(0, this.loadedSubjects.length);
                this.setPosition();
            }
            if (this.displayAs == 'global-cr' && pg == 0 && (ret.length > 1 || ALL_TEAMS.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0)) {
                ret.unshift({
                    fullName: ALL_TEAMS,
                    isFormerTeamMember: false,
                    isFrozen: false,
                    firstName: '',
                    lastName: '',
                    projectName: '',
                    customChoice: true,
                    slug: 'all-teams',
                    subjectId: '0'
                });
            }

            ret.forEach((item) => {
                if (!!this.multiple && !!this.multipleSelectedValue.find(x => x.subjectId == item.subjectId)) {
                    item.selected = true;
                }
                this.loadedSubjects.push(item);
            });
            this.moreTeamsToLoad = (ret.length > 0);

            this.setPosition();
            this.dataLoading = false;
            if (el.length > 0) {
                (el.scope() as any).$mdAutocompleteCtrl.loading = false;
            }
            deferred.resolve(ret);
        });
        return deferred.promise;
    }

    searchTextChange = (srch: string) => {
        if (this.searchQuery != srch) {
            //To format the text according to searchFormat and searchPattern
            if (!!this.searchFormat && !!this.searchPattern) {
                let cleaned = ('' + srch).replace(/\D/g, '');
                let rx = new RegExp(this.searchPattern);
                let match = cleaned.match(rx);
                if (match) {
                    let res = jsonLogic.apply(JSON.parse(this.searchFormat), match);
                    this.searchQuery = res;
                    this.searchText = res;
                } else {
                    this.searchText = srch;
                    this.searchQuery = srch;
                }
            } else {
                this.searchQuery = srch;
            }

            this.moreTeams(0, true);
        }

    }

    selectedItemChange = (team, $event) => {
        let subListVm: any = this;
        if (!!team && !!team.subjectId) {
            if (!!this.mugshotBelow && !!this.multiple) {
                this.searchText = this.searchQuery;
            }
            if (!this.selectedValue || team.subjectId != this.selectedValue.subjectId) {
                if (this.displayAs == 'global-cr') {
                    angular.element(".global-cr-height md-autocomplete input").blur();
                } else {
                    this.tempItem = team;
                    if (!!this.mugshotBelow && !this.multiple) {
                        this.selectedValue = team;
                        (document.querySelector(".team-member-directive md-autocomplete input") as HTMLInputElement).value = "";
                    } else if (!!this.mugshotBelow && !!this.multiple) {
                        if (!!team.selected) {
                            let subId;
                            if (!!team.person) {
                                subId = team.person.subjectId;
                                team.person.selected = false;
                            } else {
                                subId = team.subjectId;
                                team.selected = false;
                            }

                            this.multipleSelectedValue = this.multipleSelectedValue.filter((recipient) => {
                                return recipient.subjectId != subId;
                            });
                        } else {
                            this.multipleSelectedValue.push(team);
                            team.selected = true;
                            (this.displayAs == 'manage-cr') && (team.isActiveTeamMember = true);
                        }
                        this.selectedItem = undefined;
                    } else {
                        this.selectedValue = (this.displayAs == 'analytics-field-cr' || this.displayAs == 'form-cr') ? team : team.subjectId;
                        if (this.isEdge) {
                            angular.element(".team-member-directive md-autocomplete input").select();
                            if (window.getSelection) {
                                window.getSelection().removeAllRanges();
                            }
                        }
                        angular.element(".team-member-directive md-autocomplete input").blur();
                    }

                }
                if (!this.multiple || this.displayAs == 'analytics-field-multiple-cr') {
                    (this.displayAs != 'analytics-field-multiple-cr') && this.inputBlurred();
                    this.$timeout(function () {
                        subListVm.selectedChange({selectedItem: team});
                    }, 0);
                }
            } else if ((!!this.selectedValue || team.subjectId == this.selectedValue.subjectId) && this.displayAs == 'global-cr') {
                angular.element(".global-cr-height md-autocomplete input").blur();
                this.inputBlurred();
            }
        } else {
            return;
        }
    }

    keyUp = (str, customItem, select) => {
        let component = angular.element(".md-autocomplete-suggestions-container li > md-autocomplete-parent-scope > .highlightSelected")
        if (!!component[0]) {
            component[0].classList.remove("highlightSelected")
        }
        if (this.addNewMsg != null && this.canUsrCreateTeam) {
            if (str.keyCode == 13 && (!!this.tempItem || !!this.selectedItem) && !this.multiple) {
                angular.element(".team-member-directive md-autocomplete input").blur();
            }
            if (str.keyCode == 13 && !!customItem && this.loadedSubjects.length == 0) {
                this.PaymentService.checkLimitAndProceed("team", () => {
                    this.teamLimit = true;
                    this.clickOnNotFound({customItem: customItem});
                });
            }
        }
    }

    addOnNotfound = (event, customItem, addbtn) => {
        event.preventDefault();
        if (!!this.tempItem || !!this.selectedItem || !addbtn) {
            this.inputBlurred();
            angular.element(".team-member-directive md-autocomplete input").blur();
        }
        if (!!addbtn) {
            this.clickedOnBtn = true;
        }
        let subListVm: any = this;
        this.clickOnNotFound({customItem: customItem});
        this.$timeout(function () {
            subListVm.clickedOnBtn = false;
        }, 1000)
    }


    inputClicked = (ev) => {
        if (!this.isFocused && !(this.fieldDisabled || !!ev.currentTarget.attributes.disabled)) {
            this.isFocused = true;
            this.$timeout(() => {
                $("#" + this.displayAs + "-" + this.fieldName + "-inpt .md-virtual-repeat-scroller").animate({
                    scrollTop: 0
                }, 0);
                this.showAddBtn = true;
            }, 500);
            if (this.isEdgeIE && this.displayAs == 'global-cr') {
                let el = angular.element(".global-cr-height md-autocomplete input");
                (el.scope() as any).$mdAutocompleteCtrl.isReadonly = false;
                let subListVm: any = this;
                this.$timeout(function () {
                    if (subListVm.searchText == '') {
                        el.select().focus();
                    }
                }, 0)
            }
            if (!!this.selectedItem) {
                this.tempItem = this.selectedItem;
                this.searchText = '';
            }
        }
    }

    openDropdown = () => {
        if (this.fieldDisabled || this.disableCnd === "true" || (this.disableCnd as any) === true) {
            return;
        }
        this.$timeout(() => {
            let el = angular.element("#" + this.fieldName + "-drpdwn input");
            el.focus();
            this.inputClicked({ currentTarget: el[0] });
        }, 0);
    }

    inputBlurred = () => {
        let subListVm: any = this;
        if (!!subListVm.isFocused) {
            subListVm.isFocused = false;
            this.$timeout(() => {
                subListVm.showAddBtn = false;
            }, 500);


            if (this.isEdgeIE && this.displayAs == 'global-cr') {
                let el = angular.element(".global-cr-height md-autocomplete input");
                (el.scope() as any).$mdAutocompleteCtrl.isReadonly = true;
            }
            if (subListVm.displayAs == 'global-cr' && subListVm.selectedValue == null) {
                angular.element(".global-cr-height md-autocomplete input").blur();
            }

            if (subListVm.displayAs == 'global-cr' && subListVm.selectedItem == null) {
                //Cancel self-assign form action
                if (subListVm.$rootScope.qckAssgnFrm) {
                    subListVm.$rootScope.qckAssgnFrm = null;
                    this.$timeout(function () {
                        //WEB-11790 : If user has clicked the self assign button again then do not show cancel toastr.
                        if (!subListVm.$rootScope.qckAssgnFrm)
                            toastr.success(Util.CANCEL_SELF_ASSIGN_FORM);
                    }, 500);
                }
                //Cancel share resource folder document action
                if (subListVm.$rootScope.openShare) {
                    subListVm.$rootScope.openShare = null;
                    this.$timeout(function () {
                        if (!subListVm.$rootScope.openShare)
                            toastr.success(Util.CANCEL_SHARE);
                    }, 500);
                }
            }

            if (!!subListVm.tempItem && subListVm.displayAs != 'global-cr' && !subListVm.mugshotBelow) {
                subListVm.setPreviousItem(subListVm.tempItem);
            } else if (subListVm.displayAs == 'global-cr' && !subListVm.clickedOnBtn) {
                subListVm.setPreviousItem(subListVm.selectedValue)
            }
        }
        if (!!this.mugshotBelow || (this.displayAs == 'assign-form-cr' && !this.selectedItem)) {
            this.searchText = '';
        } else if (this.selectedValue == undefined && this.displayAs == 'global-cr') {
            this.searchText = '';
            (document.querySelector(".global-cr-height md-autocomplete input") as HTMLInputElement).value = ""
        }
    }

    setPreviousItem = (team) => {
        this.selectedItem = team;
        !!team && (this.searchText = team.fullName);
        this.tempItem = undefined;
    }
}

function ecvPaginatedSubjList(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/crSelector/directives/paginated-subj-list/paginated-subj-list.directive.html',
        replace: true,
        scope: true,
        controller: EcvPaginatedSubjList,
        controllerAs: 'subListVm',
        bindToController: {
            'selectedChange': '&',
            'clickOnNotFound': '&',
            'selectedValue': '=',
            'multipleSelectedValue': '=',
            'teamLimit': '=?limit',
            'fieldDisabled': '=?disable',
            'displayAs': '@displayAs',
            'teamPlaceholder': '@teamPlaceholder',
            'formName': '@formName',
            'label': '@label',
            'addNewMsg': '@',
            'multiple': '@',
            'mugshotBelow': '@mugshotBelowInput',
            'sendingSelectedTeam': '@',
            'fieldName': '@',
            'mgshtTooltipClass': '@',
            'formSubmitted': '=',
            'filterConfig': '=',
            'loadedSubjects': '=',
            'checkAccess': '=',
            'permissionCheck': '@',
            "withoutCache": "=?",
            "includeCustomAttributes": '=?',
            "searchBy": '=?',
            "isRequired": '=?',
            "disableCnd": '=?',
            'customFilterConfig': '=',
            "searchFormat": '@',
            "searchPattern": '@',
            "teamDetails": "=?"
        },
        link: (scope: ICustomScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPaginatedSubjList): void => {
            controller.init();
            scope.$on("$destroy", function () {
                scope.element = null;
            });
            scope.element = element;
        }
    }
}

angular.module('eCareVault.common.crSelector').directive('ecvPaginatedSubjList', ecvPaginatedSubjList);
